import { client } from '@hotjar/api-base-client';
import type { ServiceResourcesDto } from './service-resources/dto';
import type { ServiceResources } from './service-resources/model';
import { mapServiceResourcesDtoToModel } from './service-resources/mapper';

export async function getServiceResources(
  userId: number,
  accountId: number,
  filterByOwnedId = false,
): Promise<ServiceResources> {
  if (!userId) {
    throw new Error('user id is mandatory');
  }

  return client<ServiceResources, ServiceResourcesDto>({
    url: `/api/v1/users/${userId}/resources`,
    mapResponseData: (data) =>
      mapServiceResourcesDtoToModel(data, filterByOwnedId ? accountId : undefined),
  });
}
